import { Api_routes, server_url } from '../config/API_Routes';
import { getRequest, patchRequest, postRequest,deleteRequest } from '../config/axios-config';

export const getTeamMembers = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getTeamMembers
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export const createNewTeamMember = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createNewTeamMember,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export const updateTeamMember = (body, id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateTeamMember + '/' + id,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export const deleteTeamMember = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await deleteRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateTeamMember + '/' + id
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export const resendTeamInvite = (id) => {
  const body = {};
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.resendTeam + '/' + id,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};
